import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vShow as _vShow, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = {
  key: 1,
  class: "card"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "title mb-0" }
const _hoisted_7 = { class: "breadcrumb-wrap mt-1" }
const _hoisted_8 = { "aria-label": "breadcrumb" }
const _hoisted_9 = { class: "breadcrumb mb-0" }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_11 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_12 = {
  href: "javascript:void(0)",
  class: "breadcrumb-item active"
}
const _hoisted_13 = { class: "col-md-12" }
const _hoisted_14 = { class: "text-md-right" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "inline-items text-md-right align-middle mt-2" }
const _hoisted_22 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_23 = {
  key: 1,
  class: "mr-3"
}
const _hoisted_24 = { class: "table-responsive my-3 font-12" }
const _hoisted_25 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_26 = { class: "table-primary nowrap-text" }
const _hoisted_27 = { scope: "col" }
const _hoisted_28 = { scope: "col" }
const _hoisted_29 = { class: "form-check pl-0" }
const _hoisted_30 = {
  class: "form-check-label ml-3",
  for: "defaultCheck1"
}
const _hoisted_31 = { scope: "col" }
const _hoisted_32 = { class: "form-check pl-0" }
const _hoisted_33 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_34 = { scope: "col" }
const _hoisted_35 = { class: "form-check pl-0" }
const _hoisted_36 = {
  class: "form-check-label ml-3",
  for: "defaultCheck3"
}
const _hoisted_37 = { scope: "col" }
const _hoisted_38 = { class: "form-check pl-0" }
const _hoisted_39 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_40 = { scope: "col" }
const _hoisted_41 = { class: "form-check pl-0" }
const _hoisted_42 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_43 = { scope: "col" }
const _hoisted_44 = { class: "form-check pl-0" }
const _hoisted_45 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_46 = { scope: "col" }
const _hoisted_47 = { class: "form-check pl-0" }
const _hoisted_48 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_49 = { scope: "col" }
const _hoisted_50 = { class: "form-check pl-0" }
const _hoisted_51 = {
  class: "form-check-label ml-3",
  for: "defaultCheck5"
}
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "desc-wrap" }
const _hoisted_55 = { class: "text-nowrap" }
const _hoisted_56 = { class: "text-nowrap" }
const _hoisted_57 = { class: "text-nowrap" }
const _hoisted_58 = { class: "text-nowrap" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "text-nowrap" }
const _hoisted_62 = { class: "text-nowrap" }
const _hoisted_63 = /*#__PURE__*/_createVNode("td", { colspan: 7 }, null, -1)
const _hoisted_64 = { class: "text-nowrap" }
const _hoisted_65 = { class: "text-nowrap" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-12" }
const _hoisted_68 = { class: "text-md-right" }
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_70 = {
  key: 0,
  class: "my-3"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = {
  key: 2,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_74 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_75 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_76 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_77 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_78 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_79 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_80 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_81 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_82 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_83 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_84 = { class: "inline-items mt-3" }
const _hoisted_85 = {
  key: 0,
  class: "form-group"
}
const _hoisted_86 = { class: "signature-wrap" }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = { class: "inline-items" }
const _hoisted_89 = { class: "upload-btn-wrapper" }
const _hoisted_90 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "upload-btn-wrapper" }
const _hoisted_95 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_96 = { class: "form-wrap mt-2" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = { for: "" }
const _hoisted_99 = { class: "absolute-mic-wrap" }
const _hoisted_100 = { class: "bg-light p-2 rounded border mb-3" }
const _hoisted_101 = {
  key: 0,
  class: "row mx-n2"
}
const _hoisted_102 = {
  key: 0,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_103 = { class: "row mx-n2" }
const _hoisted_104 = { class: "col-xl-6 px-2" }
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { for: "" }
const _hoisted_107 = { class: "text-red" }
const _hoisted_108 = { class: "col-xl-6 px-2" }
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = { for: "" }
const _hoisted_111 = { class: "col-xl-6 px-2" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = { for: "" }
const _hoisted_114 = { class: "col-xl-6 px-2" }
const _hoisted_115 = { class: "form-group" }
const _hoisted_116 = { for: "" }
const _hoisted_117 = { class: "input-group" }
const _hoisted_118 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_119 = { class: "text-red" }
const _hoisted_120 = { class: "col-xl-6 px-2" }
const _hoisted_121 = { class: "form-group" }
const _hoisted_122 = { for: "" }
const _hoisted_123 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_124 = { class: "form-check form-check-inline" }
const _hoisted_125 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_126 = { class: "form-check form-check-inline" }
const _hoisted_127 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_128 = { class: "text-red" }
const _hoisted_129 = { class: "col-xl-6 px-2" }
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = { for: "projectAddress" }
const _hoisted_132 = { class: "text-end" }
const _hoisted_133 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_134 = {
  key: 1,
  class: "shadowed-card bg-white h-100 p-2"
}
const _hoisted_135 = { class: "text-end" }
const _hoisted_136 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_137 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_138 = { class: "row mx-n2" }
const _hoisted_139 = { class: "col-xl-6 px-2" }
const _hoisted_140 = { class: "mb-3" }
const _hoisted_141 = { class: "col-xl-6 px-2" }
const _hoisted_142 = { class: "mb-3" }
const _hoisted_143 = { class: "col-xl-6 px-2" }
const _hoisted_144 = { class: "mb-3" }
const _hoisted_145 = { class: "col-xl-6 px-2" }
const _hoisted_146 = { class: "mb-3" }
const _hoisted_147 = { class: "col-xl-6 px-2" }
const _hoisted_148 = { class: "mb-3" }
const _hoisted_149 = { key: 0 }
const _hoisted_150 = /*#__PURE__*/_createTextVNode("       ")
const _hoisted_151 = { key: 1 }
const _hoisted_152 = { class: "col-xl-6 px-2" }
const _hoisted_153 = { class: "mb-3" }
const _hoisted_154 = {
  key: 1,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_155 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_156 = { class: "row" }
const _hoisted_157 = { class: "col-md-6" }
const _hoisted_158 = { class: "form-wrap mt-2" }
const _hoisted_159 = { class: "form-group" }
const _hoisted_160 = { for: "" }
const _hoisted_161 = { class: "col-md-6" }
const _hoisted_162 = { class: "form-wrap mt-2" }
const _hoisted_163 = { class: "form-group" }
const _hoisted_164 = { for: "" }
const _hoisted_165 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_166 = { class: "row" }
const _hoisted_167 = { class: "col-md-6" }
const _hoisted_168 = { class: "form-check pl-0" }
const _hoisted_169 = {
  class: "form-check-label ml-3",
  for: "defaultCheck6"
}
const _hoisted_170 = { class: "col-md-6 text-md-end" }
const _hoisted_171 = {
  href: "#",
  class: "btn default-btn btn-outline",
  "data-toggle": "modal",
  "data-target": "#previewModal"
}
const _hoisted_172 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_173 = {
  key: 3,
  class: "row"
}
const _hoisted_174 = { class: "col-md-12 error-list mt-3" }
const _hoisted_175 = { class: "form-group" }
const _hoisted_176 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_177 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_178 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "previewModal",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_179 = { class: "modal-dialog" }
const _hoisted_180 = { class: "modal-content" }
const _hoisted_181 = { class: "modal-header" }
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "col-md-12" }
const _hoisted_184 = { class: "text-md-right" }
const _hoisted_185 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_186 = { class: "modal-body bg-light" }
const _hoisted_187 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_188 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_189 = { class: "flex-grow-1" }
const _hoisted_190 = { class: "invoice-logo" }
const _hoisted_191 = { class: "invoice-address" }
const _hoisted_192 = { class: "uppercase-text" }
const _hoisted_193 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_194 = { class: "text-muted" }
const _hoisted_195 = { class: "text-muted" }
const _hoisted_196 = { key: 1 }
const _hoisted_197 = {
  key: 2,
  class: "row"
}
const _hoisted_198 = { class: "col-md-3" }
const _hoisted_199 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_200 = { class: "col-md-3" }
const _hoisted_201 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_202 = { class: "col-md-3" }
const _hoisted_203 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_204 = { class: "mt-3" }
const _hoisted_205 = { key: 0 }
const _hoisted_206 = { class: "row" }
const _hoisted_207 = { class: "mt-3 border p-2" }
const _hoisted_208 = { key: 0 }
const _hoisted_209 = { key: 1 }
const _hoisted_210 = { key: 2 }
const _hoisted_211 = { class: "table-responsive mt-4 font-12" }
const _hoisted_212 = { class: "table mb-0 table-borderless" }
const _hoisted_213 = { class: "nowrap-text" }
const _hoisted_214 = { class: "table-active" }
const _hoisted_215 = { scope: "col" }
const _hoisted_216 = {
  key: 0,
  scope: "col"
}
const _hoisted_217 = {
  key: 1,
  scope: "col"
}
const _hoisted_218 = {
  key: 2,
  scope: "col"
}
const _hoisted_219 = {
  key: 3,
  scope: "col"
}
const _hoisted_220 = {
  key: 4,
  scope: "col"
}
const _hoisted_221 = {
  key: 5,
  scope: "col"
}
const _hoisted_222 = {
  key: 6,
  scope: "col"
}
const _hoisted_223 = {
  key: 7,
  scope: "col",
  class: "text-end"
}
const _hoisted_224 = { key: 0 }
const _hoisted_225 = { key: 1 }
const _hoisted_226 = { key: 0 }
const _hoisted_227 = { class: "desc-wrap" }
const _hoisted_228 = { key: 1 }
const _hoisted_229 = { key: 2 }
const _hoisted_230 = { key: 3 }
const _hoisted_231 = { key: 4 }
const _hoisted_232 = { key: 5 }
const _hoisted_233 = { key: 0 }
const _hoisted_234 = { key: 1 }
const _hoisted_235 = { key: 6 }
const _hoisted_236 = { key: 7 }
const _hoisted_237 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_238 = { class: "row justify-content-end" }
const _hoisted_239 = { class: "col-lg-4 col-md-6" }
const _hoisted_240 = { class: "total-box mb-4" }
const _hoisted_241 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_242 = { class: "border-top border-top-dashed fs-15" }
const _hoisted_243 = { scope: "row" }
const _hoisted_244 = { class: "text-end" }
const _hoisted_245 = { key: 3 }
const _hoisted_246 = {
  key: 4,
  class: "mt-4"
}
const _hoisted_247 = {
  key: 5,
  class: "tab-wrap bg-white rounded px-3 pb-3 border mt-3"
}
const _hoisted_248 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_249 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_250 = {
  class: "nav-link active",
  id: "Acknowledgement-tab",
  "data-toggle": "tab",
  "data-target": "#Acknowledgement",
  type: "button",
  role: "tab",
  "aria-controls": "Acknowledgement",
  "aria-selected": "true"
}
const _hoisted_251 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_252 = {
  class: "nav-link",
  id: "LegalStatement-tab",
  "data-toggle": "tab",
  "data-target": "#LegalStatement",
  type: "button",
  role: "tab",
  "aria-controls": "LegalStatement",
  "aria-selected": "false"
}
const _hoisted_253 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_254 = {
  class: "tab-pane fade show active",
  id: "Acknowledgement",
  role: "tabpanel",
  "aria-labelledby": "Acknowledgement-tab"
}
const _hoisted_255 = {
  class: "tab-pane fade",
  id: "LegalStatement",
  role: "tabpanel",
  "aria-labelledby": "LegalStatement-tab"
}
const _hoisted_256 = {
  key: 6,
  class: "alert alert-info mt-3"
}
const _hoisted_257 = { class: "mb-0" }
const _hoisted_258 = {
  key: 7,
  class: "row"
}
const _hoisted_259 = { class: "col-md-4 mt-4" }
const _hoisted_260 = { class: "signature-wrap mt-2" }
const _hoisted_261 = { class: "modal-wrap default-modal" }
const _hoisted_262 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_263 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_264 = { class: "modal-content" }
const _hoisted_265 = { class: "modal-header" }
const _hoisted_266 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_267 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_268 = { class: "modal-body" }
const _hoisted_269 = { class: "row" }
const _hoisted_270 = { class: "col-md-12" }
const _hoisted_271 = {
  key: 0,
  class: "form-group"
}
const _hoisted_272 = { for: "" }
const _hoisted_273 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_274 = { class: "form-group" }
const _hoisted_275 = { for: "" }
const _hoisted_276 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_277 = { class: "form-group" }
const _hoisted_278 = {
  for: "",
  class: "to-upper"
}
const _hoisted_279 = { class: "text-danger" }
const _hoisted_280 = { class: "form-group" }
const _hoisted_281 = { for: "" }
const _hoisted_282 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_283 = { class: "custom-file" }
const _hoisted_284 = { class: "upload-btn-wrapper" }
const _hoisted_285 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_286 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_287 = { class: "form-group" }
const _hoisted_288 = { for: "" }
const _hoisted_289 = { class: "form-group" }
const _hoisted_290 = { for: "" }
const _hoisted_291 = { class: "modal-footer" }
const _hoisted_292 = { class: "modal-wrap default-modal" }
const _hoisted_293 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_294 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_295 = { class: "modal-content" }
const _hoisted_296 = { class: "modal-header" }
const _hoisted_297 = {
  class: "modal-title",
  id: "deleteModalLabel"
}
const _hoisted_298 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_299 = { class: "modal-body" }
const _hoisted_300 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_301 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_VoiceToText = _resolveComponent("VoiceToText")
  const _component_GoogleAddressCustomer = _resolveComponent("GoogleAddressCustomer")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_Editor = _resolveComponent("Editor")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.getItemList)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      (!_ctx.state.ui.isLoading.getItemList)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('estimation_preview')), 1),
                _createVNode("div", _hoisted_7, [
                  _createVNode("nav", _hoisted_8, [
                    _createVNode("ol", _hoisted_9, [
                      _hoisted_10,
                      _createVNode("li", _hoisted_11, [
                        _createVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('estimation_preview')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
                  }, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_16, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.sendJobEstimation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("h3", _hoisted_19, _toDisplayString(_ctx.state.sendData.title), 1)
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1)
                ]),
                (_ctx.state.data.modifiedCreatedDate)
                  ? (_openBlock(), _createBlock("li", _hoisted_22, _toDisplayString(_ctx.state.data.modifiedCreatedDate), 1))
                  : (_openBlock(), _createBlock("li", _hoisted_23, _toDisplayString(_ctx.state.selectedDate), 1)),
                _createVNode("li", null, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('estimation_no')) + ":", 1)
                ]),
                _createVNode("li", null, _toDisplayString(_ctx.state.sendData.no), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_24, [
          _createVNode("table", _hoisted_25, [
            _createVNode("thead", _hoisted_26, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('item')), 1),
                _createVNode("th", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.fields.description = $event)),
                      id: "defaultCheck1"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.description]
                    ]),
                    _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('description')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.fields.quantity = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.quantity]
                    ]),
                    _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('qty')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.fields.unit = $event)),
                      id: "defaultCheck3"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.unit]
                    ]),
                    _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('unit')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_37, [
                  _createVNode("div", _hoisted_38, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.fields.cost = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.cost]
                    ]),
                    _createVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('cost')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.fields.subTotal = $event)),
                      id: "defaultCheck2"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.subTotal]
                    ]),
                    _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('sub_total')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.fields.markup = $event)),
                      id: "defaultCheck4"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.markup]
                    ]),
                    _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('markup')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.fields.allowance = $event)),
                      id: "defaultCheck4"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.allowance]
                    ]),
                    _createVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('allowance')), 1)
                  ])
                ]),
                _createVNode("th", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input mt-0 ml-0",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.fields.total = $event)),
                      id: "defaultCheck5"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.fields.total]
                    ]),
                    _createVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('total')), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                  _createVNode("td", null, [
                    (item.item.parent_id)
                      ? (_openBlock(), _createBlock("p", _hoisted_52, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_53, _toDisplayString(item.name), 1))
                  ]),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_54, [
                      _createVNode("p", null, _toDisplayString(item.description), 1)
                    ])
                  ]),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(item.quantity), 1)
                  ]),
                  _createVNode("td", _hoisted_55, [
                    _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                  ]),
                  _createVNode("td", _hoisted_56, [
                    _createVNode("p", null, _toDisplayString(item.cost), 1)
                  ]),
                  _createVNode("td", _hoisted_57, [
                    _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                  ]),
                  _createVNode("td", _hoisted_58, [
                    (item.markup_type == 1)
                      ? (_openBlock(), _createBlock("p", _hoisted_59, _toDisplayString(item.markup) + " %", 1))
                      : (_openBlock(), _createBlock("p", _hoisted_60, _toDisplayString(item.markup), 1))
                  ]),
                  _createVNode("td", _hoisted_61, [
                    _createVNode("p", null, _toDisplayString(item.allowance), 1)
                  ]),
                  _createVNode("td", _hoisted_62, [
                    _createVNode("p", null, _toDisplayString(item.total), 1)
                  ])
                ]))
              }), 128)),
              _createVNode("tr", null, [
                _hoisted_63,
                _createVNode("td", _hoisted_64, _toDisplayString(_ctx.$t('total')), 1),
                _createVNode("td", _hoisted_65, [
                  _createVNode("p", null, _toDisplayString(_ctx.totalCost), 1)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_66, [
          _createVNode("div", _hoisted_67, [
            _createVNode("div", _hoisted_68, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn btn-outline",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.estimationPreview && _ctx.estimationPreview(...args))),
                "data-target": "#previewModal"
              }, [
                _hoisted_69,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('estimation_preview')), 1)
              ])
            ])
          ])
        ]),
        (!_ctx.state.data.companyInfo.logo)
          ? (_openBlock(), _createBlock("div", _hoisted_70, [
              _createVNode("a", {
                "data-toggle": "modal",
                class: "btn default-btn d-inline-block mr-2",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
              }, _toDisplayString(_ctx.$t('add_company_information')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.companyInfo.acknowledgement &&
                _ctx.state.data.companyInfo.legal_statement
            )
          ? (_openBlock(), _createBlock("p", _hoisted_71, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.data.companyInfo.acknowledgement &&
                _ctx.state.data.companyInfo.legal_statement
            )
          ? (_openBlock(), _createBlock("div", _hoisted_72, [
              _createVNode("p", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
                _createVNode("a", {
                  class: "btn default-btn btn-sm ms-2",
                  title: "Edit",
                  href: "javascript:void(0)",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
                }, [
                  _hoisted_73,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                ])
              ]),
              (_ctx.state.data.companyInfo.logo)
                ? (_openBlock(), _createBlock("div", _hoisted_74, [
                    (_ctx.state.data.companyInfo.logo && _ctx.state.data.companyInfo.logo.file)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "rounded",
                          src: _ctx.state.data.companyInfo.logo.file
                        ? _ctx.state.data.companyInfo.logo.file
                        : _ctx.state.data.companyInfo.logo
                        ,
                          alt: ""
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          class: "rounded",
                          src: _ctx.state.data.companyInfo.logo,
                          alt: ""
                        }, null, 8, ["src"]))
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_75, [
                _createVNode("ul", _hoisted_76, [
                  _createVNode("li", _hoisted_77, [
                    _createVNode("button", _hoisted_78, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                  ]),
                  _createVNode("li", _hoisted_79, [
                    _createVNode("button", _hoisted_80, _toDisplayString(_ctx.$t('legal_statement')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", _hoisted_82, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.data.companyInfo.acknowledgement
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _createVNode("div", {
                      innerHTML: _ctx.state.data.companyInfo.legal_statement
                    }, null, 8, ["innerHTML"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_84, [
          _createVNode("ul", null, [
            _createVNode("li", null, [
              (_ctx.state.data.cropSignature)
                ? (_openBlock(), _createBlock("div", _hoisted_85, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_86, [
                        _createVNode("img", {
                          src: _ctx.state.data.cropSignature,
                          alt: ""
                        }, null, 8, ["src"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_87, [
                _createVNode("div", _hoisted_88, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode("div", _hoisted_89, [
                        _createVNode("button", _hoisted_90, [
                          _hoisted_91,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                        ]),
                        _createVNode("input", {
                          type: "file",
                          accept: "image/png, image/jpeg",
                          id: "profileUpdate",
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                        }, null, 32)
                      ])
                    ]),
                    _createVNode("li", null, [
                      _createVNode("button", {
                        class: "btn default-btn",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                      }, [
                        _hoisted_92,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                      ])
                    ]),
                    (_ctx.state.data.haveProfileSign)
                      ? (_openBlock(), _createBlock("li", _hoisted_93, [
                          _createVNode("div", _hoisted_94, [
                            _createVNode("button", {
                              for: "formFileSm",
                              class: "btn default-btn mr-2",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userSignature('use')))
                            }, [
                              _hoisted_95,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("li", null, [
                      _createVNode("button", {
                        class: "btn red-btn",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.clearSignature()))
                      }, _toDisplayString(_ctx.$t('clear')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_96, [
          _createVNode("div", _hoisted_97, [
            _createVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('note')), 1),
            _withDirectives(_createVNode("textarea", {
              class: "form-control h-auto",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.note = $event)),
              rows: 10
            }, null, 512), [
              [_vModelText, _ctx.state.data.note]
            ]),
            _createVNode("div", _hoisted_99, [
              _createVNode(_component_VoiceToText, {
                onStartRecording: _cache[18] || (_cache[18] = ($event: any) => (_ctx.startRecording($event)))
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_100, [
          (_ctx.state.data.selectedCustomers.length)
            ? (_openBlock(), _createBlock("div", _hoisted_101, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-md-4 col-sm-6 mb-2 px-2",
                    key: customerIndex
                  }, [
                    (customer.isEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_102, [
                          _createVNode("div", _hoisted_103, [
                            _createVNode("div", _hoisted_104, [
                              _createVNode("div", _hoisted_105, [
                                _createVNode("label", _hoisted_106, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                ]),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  disabled: "",
                                  class: customer.emailError
                                            ? 'form-control error-field'
                                            : 'form-control'
                                            ,
                                  "onUpdate:modelValue": ($event: any) => (customer.email = $event)
                                }, null, 10, ["onUpdate:modelValue"]), [
                                  [_vModelText, customer.email]
                                ]),
                                _createVNode("p", _hoisted_107, _toDisplayString(customer.emailError), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_108, [
                              _createVNode("div", _hoisted_109, [
                                _createVNode("label", _hoisted_110, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                ]),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => (customer.first_name = $event)
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, customer.first_name]
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_111, [
                              _createVNode("div", _hoisted_112, [
                                _createVNode("label", _hoisted_113, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                ]),
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => (customer.last_name = $event)
                                }, null, 8, ["onUpdate:modelValue"]), [
                                  [_vModelText, customer.last_name]
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_114, [
                              _createVNode("div", _hoisted_115, [
                                _createVNode("label", _hoisted_116, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                ]),
                                _createVNode("div", _hoisted_117, [
                                  _hoisted_118,
                                  _withDirectives(_createVNode("input", {
                                    type: "number",
                                    class: customer.phoneError ? 'form-control error-field' : 'form-control',
                                    placeholder: _ctx.$t('mobile_number_only'),
                                    "onUpdate:modelValue": ($event: any) => (customer.phone = $event)
                                  }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                                    [_vModelText, customer.phone]
                                  ])
                                ]),
                                _createVNode("p", _hoisted_119, _toDisplayString(customer.phoneError), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_120, [
                              _createVNode("div", _hoisted_121, [
                                _createVNode("label", _hoisted_122, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                ]),
                                _createVNode("div", _hoisted_123, [
                                  _createVNode("div", _hoisted_124, [
                                    _withDirectives(_createVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "inlineCheckbox1",
                                      value: "true",
                                      "onUpdate:modelValue": ($event: any) => (customer.mailNotification = $event),
                                      checked: "",
                                      disabled: ""
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelCheckbox, customer.mailNotification]
                                    ]),
                                    _createVNode("label", _hoisted_125, _toDisplayString(_ctx.$t('email')), 1)
                                  ]),
                                  _createVNode("div", _hoisted_126, [
                                    _withDirectives(_createVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "inlineCheckbox2",
                                      value: "true",
                                      "onUpdate:modelValue": ($event: any) => (customer.smsNotification = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelCheckbox, customer.smsNotification]
                                    ]),
                                    _createVNode("label", _hoisted_127, _toDisplayString(_ctx.$t('sms')), 1)
                                  ])
                                ]),
                                _createVNode("p", _hoisted_128, _toDisplayString(customer.mailNotificationError), 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_129, [
                              _createVNode("div", _hoisted_130, [
                                _createVNode("label", _hoisted_131, [
                                  _createVNode("small", null, _toDisplayString(_ctx.$t('address')), 1)
                                ]),
                                _createVNode(_component_GoogleAddressCustomer, {
                                  latitude: _ctx.latitude,
                                  longitude: _ctx.longitude,
                                  address: customer.address_line1,
                                  visible: _ctx.showMap,
                                  isEdit: true,
                                  "onUpdate:latitude": _ctx.updateLatitude,
                                  "onUpdate:longitude": _ctx.updateLongitude,
                                  "onUpdate:address": _ctx.updateAddress
                                }, null, 8, ["latitude", "longitude", "address", "visible", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_132, [
                            _createVNode("a", {
                              class: "btn default-btn btn-sm",
                              title: "Update",
                              href: "javascript:void(\n                            0)",
                              onClick: ($event: any) => (_ctx.updateSelectCustomer(customerIndex))
                            }, [
                              _hoisted_133,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('update')), 1)
                            ], 8, ["onClick"])
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_134, [
                          _createVNode("div", _hoisted_135, [
                            _createVNode("a", {
                              class: "btn default-btn btn-sm mr-2",
                              title: "Edit",
                              href: "javascript:void(\n                            0)",
                              onClick: ($event: any) => (_ctx.editSelectCustomer(customerIndex))
                            }, [
                              _hoisted_136,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                            ], 8, ["onClick"]),
                            _createVNode("a", {
                              class: "btn btn-sm red-btn",
                              title: "Delete",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.showDelete(customer))
                            }, [
                              _hoisted_137,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                            ], 8, ["onClick"])
                          ]),
                          _createVNode("div", _hoisted_138, [
                            _createVNode("div", _hoisted_139, [
                              _createVNode("div", _hoisted_140, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(customer.email), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_141, [
                              _createVNode("div", _hoisted_142, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('first_name')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(customer.first_name), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_143, [
                              _createVNode("div", _hoisted_144, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('last_name')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(customer.last_name), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_145, [
                              _createVNode("div", _hoisted_146, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(customer.phone), 1)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_147, [
                              _createVNode("div", _hoisted_148, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  (customer.mailNotification)
                                    ? (_openBlock(), _createBlock("small", _hoisted_149, _toDisplayString(_ctx.$t('mail')), 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_150,
                                  (customer.smsNotification)
                                    ? (_openBlock(), _createBlock("small", _hoisted_151, _toDisplayString(_ctx.$t('sms')), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_152, [
                              _createVNode("div", _hoisted_153, [
                                _createVNode("p", null, [
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                                  ])
                                ]),
                                _createVNode("p", null, [
                                  _createVNode("small", null, _toDisplayString(customer.address_line1), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_154, [
                _hoisted_155,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_not_selected')) + " " + _toDisplayString(_ctx.$t('please_select_or_add_customer_email')), 1)
              ]))
        ]),
        _createVNode("div", _hoisted_156, [
          _createVNode("div", _hoisted_157, [
            _createVNode("div", _hoisted_158, [
              _createVNode("div", _hoisted_159, [
                _createVNode("label", _hoisted_160, _toDisplayString(_ctx.$t('customer_emails')), 1),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.state.data.selectedPhones,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.selectedPhones = $event)),
                  "tag-placeholder": "Select or add customer phone",
                  placeholder: _ctx.$t('select_add_customer_phone'),
                  label: "code",
                  "track-by": "code",
                  options: _ctx.state.data.allCustomer,
                  multiple: true,
                  taggable: true,
                  onTag: _ctx.addCustomerEmail,
                  onSelect: _ctx.changeValue
                }, null, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
                _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_not_owner_email_only')), 513), [
                  [_vShow, _ctx.isInvalid]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_161, [
            _createVNode("div", _hoisted_162, [
              _createVNode("div", _hoisted_163, [
                _createVNode("label", _hoisted_164, _toDisplayString(_ctx.$t('customer_mobile_number')), 1),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.state.data.allPhones,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.data.allPhones = $event)),
                  "tag-placeholder": "Select or add customer phone",
                  placeholder: _ctx.$t('select_add_customer_phone'),
                  label: "code",
                  "track-by": "code",
                  options: _ctx.state.data.allPhones,
                  multiple: true,
                  taggable: true,
                  onTag: _ctx.addCustomerPhone,
                  onSelect: _ctx.changePhoneValue
                }, {
                  default: _withCtx(() => [
                    _hoisted_165
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "options", "onTag", "onSelect"]),
                _withDirectives(_createVNode("p", { class: "text-red" }, _toDisplayString(_ctx.$t('please_add_valid_not_owner_phone_only')), 513), [
                  [_vShow, _ctx.isPhoneInvalid]
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_166, [
          _createVNode("div", _hoisted_167, [
            _createVNode("div", _hoisted_168, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input mt-0 ml-0",
                type: "checkbox",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.approveByAll = $event)),
                id: "defaultCheck6"
              }, null, 512), [
                [_vModelCheckbox, _ctx.state.approveByAll]
              ]),
              _createVNode("label", _hoisted_169, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_170, [
            _createVNode("a", _hoisted_171, [
              _hoisted_172,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('preview')), 1)
            ])
          ])
        ]),
        (_ctx.state.ui.errors.errorList.sendJobEstimation && _ctx.state.ui.errors.errorList.sendJobEstimation.length && _ctx.state.ui.errors.hasError)
          ? (_openBlock(), _createBlock("div", _hoisted_173, [
              _createVNode("div", _hoisted_174, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('errors_scroll_up')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_175, [
          _createVNode("button", {
            type: "submit",
            class: "btn default-btn mr-2",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.sendJobEstimation && _ctx.sendJobEstimation(...args))),
            disabled: _ctx.state.ui.isPostLoading.sendJobEstimation
          }, _toDisplayString(_ctx.state.ui.isPostLoading.sendJobEstimation ?
                        _ctx.$t('loading1') : _ctx.$t('send')), 9, ["disabled"]),
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline d-inline-block",
            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.gotoListJobEstimation && _ctx.gotoListJobEstimation(...args)))
          }, [
            _hoisted_176,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_177, [
        _createVNode("div", _hoisted_178, [
          _createVNode("div", _hoisted_179, [
            _createVNode("div", _hoisted_180, [
              _createVNode("div", _hoisted_181, [
                _createVNode("div", _hoisted_182, [
                  _createVNode("div", _hoisted_183, [
                    _createVNode("div", _hoisted_184, [
                      _createVNode("a", {
                        href: "javascript:void(0)",
                        class: "btn default-btn outline d-inline-block",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closePreviewModal && _ctx.closePreviewModal(...args)))
                      }, [
                        _hoisted_185,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_186, [
                _createVNode("div", _hoisted_187, [
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_188, [
                        _createVNode("div", _hoisted_189, [
                          _createVNode("div", _hoisted_190, [
                            _createVNode("img", {
                              src: _ctx.state.data.companyInfo.logo.file
                                                ? _ctx.state.data.companyInfo.logo.file
                                                : _ctx.state.data.companyInfo.logo
                                                ,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_191, [
                            _createVNode("p", null, [
                              _createVNode("strong", _hoisted_192, _toDisplayString(_ctx.$t('address')), 1)
                            ]),
                            _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_193, [
                          _createVNode("p", null, [
                            _createVNode("span", _hoisted_194, _toDisplayString(_ctx.$t('email')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_email), 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("span", _hoisted_195, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("hr", _hoisted_196))
                    : _createCommentVNode("", true),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_197, [
                        _createVNode("div", _hoisted_198, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_199, _toDisplayString(_ctx.$t('estimation_title')), 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.state.sendData.title), 1)
                        ]),
                        _createVNode("div", _hoisted_200, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_201, _toDisplayString(_ctx.$t('estimation_no')), 1)
                          ]),
                          _createVNode("p", null, "# " + _toDisplayString(_ctx.state.sendData.no), 1)
                        ]),
                        _createVNode("div", _hoisted_202, [
                          _createVNode("p", null, [
                            _createVNode("strong", _hoisted_203, _toDisplayString(_ctx.$t('date')), 1)
                          ]),
                          _createVNode("p", null, _toDisplayString(_ctx.state.selectedDate), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_204, [
                    (_ctx.state.data && _ctx.state.data.selectedCustomers && _ctx.state.data.selectedCustomers.length)
                      ? (_openBlock(), _createBlock("p", _hoisted_205, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_206, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedCustomers, (customer, customerIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "col-md-4",
                          key: customerIndex
                        }, [
                          _createVNode("div", _hoisted_207, [
                            (customer.first_name || customer.last_name)
                              ? (_openBlock(), _createBlock("p", _hoisted_208, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                  _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.email)
                              ? (_openBlock(), _createBlock("p", _hoisted_209, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.email), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.phone)
                              ? (_openBlock(), _createBlock("p", _hoisted_210, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.phone), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_211, [
                    _createVNode("table", _hoisted_212, [
                      _createVNode("thead", _hoisted_213, [
                        _createVNode("tr", _hoisted_214, [
                          _createVNode("th", _hoisted_215, _toDisplayString(_ctx.$t('item')), 1),
                          (_ctx.state.fields.description)
                            ? (_openBlock(), _createBlock("th", _hoisted_216, _toDisplayString(_ctx.$t('description')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.quantity)
                            ? (_openBlock(), _createBlock("th", _hoisted_217, _toDisplayString(_ctx.$t('qty')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.unit)
                            ? (_openBlock(), _createBlock("th", _hoisted_218, _toDisplayString(_ctx.$t('unit')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.cost)
                            ? (_openBlock(), _createBlock("th", _hoisted_219, _toDisplayString(_ctx.$t('cost')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.subTotal)
                            ? (_openBlock(), _createBlock("th", _hoisted_220, _toDisplayString(_ctx.$t('sub_total')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.markup)
                            ? (_openBlock(), _createBlock("th", _hoisted_221, _toDisplayString(_ctx.$t('markup')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.allowance)
                            ? (_openBlock(), _createBlock("th", _hoisted_222, _toDisplayString(_ctx.$t('allowance')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.total)
                            ? (_openBlock(), _createBlock("th", _hoisted_223, _toDisplayString(_ctx.$t('total')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              (item.item.parent_id)
                                ? (_openBlock(), _createBlock("p", _hoisted_224, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                                : (_openBlock(), _createBlock("p", _hoisted_225, _toDisplayString(item.name), 1))
                            ]),
                            (_ctx.state.fields.description)
                              ? (_openBlock(), _createBlock("td", _hoisted_226, [
                                  _createVNode("div", _hoisted_227, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity)
                              ? (_openBlock(), _createBlock("td", _hoisted_228, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit)
                              ? (_openBlock(), _createBlock("td", _hoisted_229, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost)
                              ? (_openBlock(), _createBlock("td", _hoisted_230, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal)
                              ? (_openBlock(), _createBlock("td", _hoisted_231, [
                                  _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup)
                              ? (_openBlock(), _createBlock("td", _hoisted_232, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_233, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_234, _toDisplayString(item.markup), 1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance)
                              ? (_openBlock(), _createBlock("td", _hoisted_235, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total)
                              ? (_openBlock(), _createBlock("td", _hoisted_236, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_237,
                  _createVNode("div", _hoisted_238, [
                    _createVNode("div", _hoisted_239, [
                      _createVNode("div", _hoisted_240, [
                        _createVNode("table", _hoisted_241, [
                          _createVNode("tbody", null, [
                            _createVNode("tr", _hoisted_242, [
                              _createVNode("th", _hoisted_243, _toDisplayString(_ctx.$t('total_amount')), 1),
                              _createVNode("th", _hoisted_244, _toDisplayString(_ctx.totalCost), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (!_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("hr", _hoisted_245))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement)
                    ? (_openBlock(), _createBlock("p", _hoisted_246, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_247, [
                        _createVNode("ul", _hoisted_248, [
                          _createVNode("li", _hoisted_249, [
                            _createVNode("button", _hoisted_250, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                          ]),
                          _createVNode("li", _hoisted_251, [
                            _createVNode("button", _hoisted_252, _toDisplayString(_ctx.$t('legal_statement1')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_253, [
                          _createVNode("div", _hoisted_254, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createVNode("div", _hoisted_255, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.note)
                    ? (_openBlock(), _createBlock("div", _hoisted_256, [
                        _createVNode("p", _hoisted_257, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ((_ctx.state.data.uploadSignature || _ctx.state.data.cropSignature) && !_ctx.state.estimationPreview)
                    ? (_openBlock(), _createBlock("div", _hoisted_258, [
                        _createVNode("div", _hoisted_259, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('signature')) + ":", 1)
                          ]),
                          _createVNode("div", _hoisted_260, [
                            _createVNode("img", {
                              src: _ctx.state.data.uploadSignature ? _ctx.state.data.uploadSignature : _ctx.state.data.cropSignature,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_261, [
        _createVNode("div", _hoisted_262, [
          _createVNode("div", _hoisted_263, [
            _createVNode("div", _hoisted_264, [
              _createVNode("div", _hoisted_265, [
                _createVNode("h5", _hoisted_266, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_267
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_268, [
                _createVNode("div", _hoisted_269, [
                  _createVNode("div", _hoisted_270, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_271, [
                          _createVNode("label", _hoisted_272, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_273, [
                        _createVNode("div", _hoisted_274, [
                          _createVNode("label", _hoisted_275, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _createVNode(_component_AppPhoneNumberInput, {
                            modelValue: _ctx.state.data.companyInfo.company_phone_number,
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_276, [
                        _createVNode("div", _hoisted_277, [
                          _createVNode("label", _hoisted_278, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "email",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event)),
                            onKeyup: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ]),
                          _createVNode("p", _hoisted_279, _toDisplayString(_ctx.state.ui.errors.companyEroor), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_280, [
                  _createVNode("label", _hoisted_281, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.companyInfo.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_282, [
                        _createVNode("img", {
                          src: _ctx.state.data.companyInfo.logo.file
                                        ? _ctx.state.data.companyInfo.logo.file
                                        : _ctx.state.data.companyInfo.logo
                                        ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_283, [
                    _createVNode("div", _hoisted_284, [
                      _createVNode("button", _hoisted_285, [
                        _hoisted_286,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_287, [
                  _createVNode("label", _hoisted_288, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.companyInfo.acknowledgement,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.state.data.companyInfo.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_289, [
                  _createVNode("label", _hoisted_290, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.companyInfo.legal_statement,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.state.data.companyInfo.legal_statement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_291, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_292, [
        _createVNode("div", _hoisted_293, [
          _createVNode("div", _hoisted_294, [
            _createVNode("div", _hoisted_295, [
              _createVNode("div", _hoisted_296, [
                _createVNode("h5", _hoisted_297, _toDisplayString(_ctx.$t('remove_customer')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_298
                ])
              ]),
              _createVNode("div", _hoisted_299, [
                _createVNode("div", _hoisted_300, _toDisplayString(_ctx.$t('are_you_sure_remove_customer')) + ". ", 1)
              ]),
              _createVNode("div", _hoisted_301, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.removeCustomer && _ctx.removeCustomer(...args)))
                }, _toDisplayString(_ctx.state.ui.isLoading.isRemoveCustomer ? _ctx.$t('loading1') : _ctx.$t('remove')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.hideDelete && _ctx.hideDelete(...args)))
                }, _toDisplayString(_ctx.$t('no')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 2,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 0,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 1,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
}